import PhoneIcon from 'material-ui/svg-icons/communication/phone';
import React from 'react';
import MediaQuery from 'react-responsive';

const style = {
  container: {
    height: '30px',
    boxSizing: 'border-box',
    borderRadius: '100px',
    display: 'flex',
    paddingBottom: '16px',
    cursor: 'pointer'
  },
  icon: {
    position: 'relative',
    textAlign: 'left',
    height: '14px',
    width: '14px',
    left: '14px',
    bottom: '2px',
    color: 'inherit',
    transition: 'none'
  },
  ctaText: {
    position: 'relative',
    left: '17px',
    top: '13.33%',
    bottom: '4px',
    fontFamily: 'Graphik-Regular',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '38px',
    alignItems: 'center',
    letterSpacing: '0.3px',
    color: 'inherit'
  }
};

export default (props) => (
  <div
    style={{ ...style.container, ...{ paddingRight: props.rightPadding ? '2em' : '' } }}
    className="hover--teal"
  >
    <a className="copy__color--white link__hover--teal" href="tel:1-844-947-2848">
      <MediaQuery maxWidth={719} style={{ width: '68px' }}>
        <PhoneIcon style={style.icon} />
        <span style={style.ctaText}>Call</span>
      </MediaQuery>
      <MediaQuery minWidth={720} style={{ width: '138px' }}>
        <PhoneIcon style={style.icon} />
        <span style={{ width: '98px', ...style.ctaText }}>(844) 947-2848</span>
      </MediaQuery>
    </a>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/header/phone-number.js